"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";
export default function VisuallyHidden({ asChild, children }) {
    return (_jsx(VisuallyHiddenPrimitive.Root, { asChild: asChild, children: children }));
}
